export const UserFilterRole = [
    {name: "PREGNANCY_SPECIALIST", value: "PREGNANCY_SPECIALIST"},
    {name: "CANCER_SPECIALIST", value: "CANCER_SPECIALIST"},
    {name: "MAMA_SPECIALIST", value: "MAMA_SPECIALIST"},
    {name: "EXPERT", value: "EXPERT"},
    {name: "NORMAL", value: "NORMAL"},
    {name: "SUPER_ADMIN", value: "SUPER_ADMIN"},
    {name: "CRM", value: "CRM"},
];

export const SpecialistCategories = [
    { id: 'داخلی و غدد', name: 'داخلی و غدد' },
    { id: 'اطفال', name: 'اطفال' },
    { id: 'مشاوره جنسی', name: 'مشاوره جنسی' },
    { id: 'مامایی', name: 'مامایی' },
    { id: 'زنان زایمان و نازایی', name: 'زنان زایمان و نازایی' },
    { id: 'پزشک عمومی', name: 'پزشک عمومی' },
    { id: 'تغدیه و رژیم درمانی', name: 'تغدیه و رژیم درمانی' },
    { id: 'اعصاب و روان', name: 'اعصاب و روان' },
    { id: 'پوست و مو', name: 'پوست و مو' },
    { id: 'سایر', name: 'سایر' },
];
